import {bootstrapDetectBreakpoint} from './bootstrapDetectBreakpoint';
import eventBus from "./event-bus";

const menuWrap = $('#mainMenuWrap');
let menu = $('#mainMenu');

const menus = [
    {
        items: menu.data('items-lg'),
        breakpoint: 3
    },
    {
        items: menu.data('items-xl'),
        breakpoint: 4
    },
    {
        items: menu.data('items-xxl'),
        breakpoint: 5
    }
]

let menuData = {};

// remove all items in menu
function clearMenu() {
    menu.empty();
}

// Add Fake menu
function setFakeMenu(itemsCount) {
    for(let i = 0; i < itemsCount; i++) {
        menu.append(`
        <li class="is-nav-item is-nav-item--first d-lg-flex" >
            <a class="is-nav-item-link flex-grow-1 fill-width-lg d-lg-flex">
                <span class="text-truncate text-lg-center px-lg-3 flex-grow-1">
                    <span class="is-fake-nav-item"></span>
                </span>
            </a>
        </li>
    `);
    }
}

// Set the size of the items by items count
function setMenuItemsSize(itemsCount, currentBreakpoint) {

    if(currentBreakpoint.index >= 3) {
        menuWrap.find('.is-nav-item--first').css('width', (100 / itemsCount) + '%');
        return;
    }
    menuWrap.find(".is-nav-item--first").css('width', '100%');
}

function appendItems(dataString) {
    menu.append(menuData[dataString].data);
}

async function getMainMenu(itemsCount, currentBreakpoint, dataString) {

    clearMenu();

    if(menuData.hasOwnProperty(dataString)) {
        appendItems(dataString);
    } else {
        setFakeMenu(itemsCount);
        let url = new URL(window.config.urls.menu);
        url.searchParams.append('max', itemsCount);
        url = url.toString();

        if(itemsCount === 0) {
            url = window.config.urls.menu
        }

        menuData[dataString] = await window.axios.get(url).catch((err) => {
            console.error(err);
        });

        clearMenu();
        appendItems(dataString);
    }

    // Emit event for more menu actions
    eventBus.emit('init-main-menu');

}

// Fill menu with data
async function fillMenu() {

    const currentBreakpoint = bootstrapDetectBreakpoint();

    for(let [i, v] of menus.entries()) {
        if(currentBreakpoint.index === v.breakpoint ) {
            await getMainMenu(v.items, currentBreakpoint, i.toString());
            return;
        }
    }

    await getMainMenu(0, currentBreakpoint);

}

(async () => await fillMenu())();

$(window).resize( async function() {
    await fillMenu();
});
